<template>
    <div id="app">
        <router-view class="page-content" />
        <FooterView></FooterView>
    </div>
</template>

<script>
import { setFavicon } from "@/utils/common";
export default {
    mounted() {
        const url =
            "https://file.gkzzd.cn/www/gkzzd/uploads/20250321/34176b7dce083448e164ba03183db7aa.ico";
        setFavicon(url);
        document.title = "高考早知道-升学、实习、就业一站式成才服务平台";
    },
};
</script>

<style lang="scss">
#app {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.page-content {
    flex: 1;
}
</style>
